import styles from './FJItem.module.less';
import classNames from 'classnames';
import FJUtil from '../../../util/FJUtil.js';

const baseUrl = 'https://resource.flexclip.com/app/subscription/img/';

const FJItem = props => {
    // eslint-disable-next-line react/prop-types
    const {
        isSelected,
        credit,
        discount,
        currentCountryMonetary,
        currentCountryMonetaryISO,
        exchangeRate,
        price,
        onClick,
    } = props;

    const originalPrice = FJUtil.preciseMultiply([parseFloat(price), exchangeRate]);
    const originalPriceString = FJUtil.formatNumberThousandth(originalPrice.toFixed(2));
    const discountPrice = FJUtil.formatNumberThousandth((originalPrice * discount).toFixed(2));

    return (
        <div className={classNames(styles.box, { [styles.isSelected]: isSelected })} onClick={onClick}>
            <div className={styles.inner}>
                <div className={styles.left}>
                    <img src={`${baseUrl}Credits-20.webp`} alt='coin' width={20} height={20} />
                    <div className={styles.credit}>{credit}</div>
                </div>
                <div className={styles.right}>
                    <span className={styles.unit}>
                        {currentCountryMonetary}
                        {currentCountryMonetaryISO}
                    </span>
                    <div className={styles.ccc}>
                        <span className={styles.current_price}>{discountPrice}</span>
                        <span className={styles.price}>
                            {currentCountryMonetary}
                            {originalPriceString}
                            <div className={styles.dis_line}></div>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FJItem;
